import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/technicalAsisitances`;

class TechnicalAssistService extends ApiHelper {
    constructor(_url: string) {
        super(_url);
    }
}
const technicalAPI = new TechnicalAssistService(url);
export default technicalAPI;
